import { createApi } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { UserLoopInfo, UserLoopInfoParams } from "@bridgesplit/abf-sdk";

import { abfSerializeQueryArgs, marketsBaseQuery } from "./util";
import { GET_USER_LOOP_INFO_ROUTE, GET_LOOP_POSITION_STATS_ROUTE } from "../constants";
import { LoopPositionStats } from "../types";

const LOOP_POSITIONS_TAG = "LoopPositions";

export const loopApi = createApi({
    reducerPath: "loopApi",
    tagTypes: [LOOP_POSITIONS_TAG],
    baseQuery: marketsBaseQuery,
    serializeQueryArgs: abfSerializeQueryArgs,
    endpoints: (builder) => ({
        userLoops: builder.query<UserLoopInfo[], { userLoopInfo: UserLoopInfoParams }>({
            providesTags: [LOOP_POSITIONS_TAG],
            query: (params) => ({
                url: GET_USER_LOOP_INFO_ROUTE,
                method: "POST",
                body: params.userLoopInfo
            })
        }),
        loopPositionStats: builder.query<LoopPositionStats, void>({
            providesTags: [LOOP_POSITIONS_TAG],
            query: () => ({
                url: GET_LOOP_POSITION_STATS_ROUTE,
                method: "GET"
            })
        })
    })
});

export const { useUserLoopsQuery, useLoopPositionStatsQuery } = loopApi;

export const useLoopApi = () => {
    const dispatch = useDispatch();

    return {
        resetLoopApi: () => dispatch(loopApi.util.invalidateTags([LOOP_POSITIONS_TAG]))
    };
};
